import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/register`;

const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
const data = request => request.then(r => r.data);

// The daily cash book (owner, 2026-11-02). Every write answers with the whole day,
// so the screen shows the server's figures, never its own arithmetic.
export const readToday = token => data(axios.get(`${API}/today`, auth(token)));
export const readDay = (day, token) => data(axios.get(`${API}/days/${day}`, auth(token)));
export const listDays = (token, params = {}) => data(axios.get(`${API}/days`, { ...auth(token), params }));
export const saveDay = (day, body, token) => data(axios.patch(`${API}/days/${day}`, body, auth(token)));
export const addEntry = (day, body, token) => data(axios.post(`${API}/days/${day}/entries`, body, auth(token)));
export const addSlip = (day, body, token) => data(axios.post(`${API}/days/${day}/slips`, body, auth(token)));
export const voidEntry = (id, reason, token) => data(axios.post(`${API}/entries/${id}/void`, { reason }, auth(token)));
export const closeDay = (day, token) => data(axios.post(`${API}/days/${day}/close`, {}, auth(token)));
export const reopenDay = (day, token) => data(axios.post(`${API}/days/${day}/reopen`, {}, auth(token)));
export const listSections = token => data(axios.get(`${API}/sections`, auth(token)));
export const createSection = (body, token) => data(axios.post(`${API}/sections`, body, auth(token)));
export const updateSection = (key, body, token) => data(axios.patch(`${API}/sections/${key}`, body, auth(token)));
export const listHeads = token => data(axios.get(`${API}/heads`, auth(token)));
export const createHead = (body, token) => data(axios.post(`${API}/heads`, body, auth(token)));
export const updateHead = (id, body, token) => data(axios.patch(`${API}/heads/${id}`, body, auth(token)));
export const deleteHead = (id, token) => data(axios.delete(`${API}/heads/${id}`, auth(token)));
export const listPaymentAccounts = token => data(axios.get(`${API}/payment-accounts`, auth(token)));
export const createPaymentAccount = (body, token) => data(axios.post(`${API}/payment-accounts`, body, auth(token)));
export const updatePaymentAccount = (id, body, token) => data(axios.patch(`${API}/payment-accounts/${id}`, body, auth(token)));
export const listCounterparties = token => data(axios.get(`${API}/counterparties`, auth(token)));
export const createCounterparty = (body, token) => data(axios.post(`${API}/counterparties`, body, auth(token)));
export const updateCounterparty = (id, body, token) => data(axios.patch(`${API}/counterparties/${id}`, body, auth(token)));
export const getCounterpartyLedger = (id, token) => data(axios.get(`${API}/counterparties/${id}/ledger`, auth(token)));
export const listSignoffSlots = (token, params = {}) => data(axios.get(`${API}/signoff-slots`, { ...auth(token), params }));
export const createSignoffSlot = (body, token) => data(axios.post(`${API}/signoff-slots`, body, auth(token)));
export const updateSignoffSlot = (id, body, token) => data(axios.patch(`${API}/signoff-slots/${id}`, body, auth(token)));
export const uploadDayAttachment = (day, file, token) => {
  const form = new FormData();
  form.append("file", file, file.name);
  return data(axios.post(`${API}/days/${day}/attachments`, form, auth(token)));
};
export const fetchDayAttachment = (id, token) =>
  data(axios.get(`${API}/attachments/${id}`, { ...auth(token), responseType: "blob" }));
export const deleteDayAttachment = (id, token) => data(axios.delete(`${API}/attachments/${id}`, auth(token)));
export const createEvent = (body, token) => data(axios.post(`${API}/events`, body, auth(token)));
export const getEventLedger = (id, token) => data(axios.get(`${API}/events/${id}`, auth(token)));
export const createPayee = (body, token) => data(axios.post(`${API}/payees`, body, auth(token)));
export const payVendor = (day, body, token) => data(axios.post(`${API}/days/${day}/vendor-payments`, body, auth(token)));
export const signSlot = (day, slotId, pin, token) => data(axios.post(`${API}/days/${day}/sign/${slotId}`, { pin }, auth(token)));

/** The server's own words for a refusal, or the fallback. */
export const failureText = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return fallback;
};
